import { render, staticRenderFns } from "./CertificateCallback.vue?vue&type=template&id=dcf18074&scoped=true&"
import script from "./CertificateCallback.vue?vue&type=script&lang=ts&"
export * from "./CertificateCallback.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateCallback.vue?vue&type=style&index=0&id=dcf18074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf18074",
  null
  
)

export default component.exports